import React from 'react';
import css from './load-more-button.css';

export default function LoadMoreButton(props) {
  return (
    <button
      className={css.root}
      onTouchTap={props.loadMore}
      disabled={props.disabled}
    >Load More</button>
  );
}



/** WEBPACK FOOTER **
 ** ./components/LoadMoreButton.js
 **/